import React from "react";
import {Printers} from "./printers/Printers";
import {HeaderTabs} from "./common/HeaderTabs";
import {QueryClient, QueryClientProvider} from 'react-query';
import {isMinimalApp} from "./CommonFunctions";

const queryClient = new QueryClient();

export const PrintersMain = () => {

    const headerLinks = [
        { label: "Imprimantes", path: "printers" },
        { label: "Stock matières premières", path: "resources", visible: !isMinimalApp() }
    ];

    return (
        <>
            <HeaderTabs links={headerLinks}/>

            <div id="main-grid__item--main-content" className="main-grid__item">
                <div id="main-content">
                    <QueryClientProvider client={queryClient}>
                        <Printers/>
                    </QueryClientProvider>
                </div>
            </div>
        </>
    )
}



